import { useRoutes } from "react-router-dom";
import CreateCard from "../../Component/CreateCard.js"
import EditFormRoute from "../../Component/Forms/EditFormRoute.js"

import AddmanageAnnouncement from "./manageAnnouncement/Create.js"
import ManageAnnouncement from "./manageAnnouncement/View.js"

import BreastCancerRecord from "./breastCancerRecord/View.js"
import StarBucksCoffeCup from "./starBucksCoffeCup/View.js"
import SuperBowl from "./superBowl/View.js"



import ProtectedRoute from "../RouteProtect.js"

const CarrierCardArray = [
    {
        title: "Manage Announcement",
        path: "manageAnnouncement",
        auth: "carrier",
    },
    {
        title: "Breast Cancer Record",
        path: "breastCancerRecord",
        auth: "carrier",
    },
    {
        title: "Star Bucks Coffe Cup",
        path: "starBucksCoffeCup",
        auth: "carrier",
    },
    {
        title: "Super Bowl",
        path: "superBowl",
        auth: "carrier",
    },
]


const RoutesArray = [
    {
        path: "/",
        element: <CreateCard cardJson={[...CarrierCardArray]} />
    },
    {
        path: "*",
        element: <h1>This is 404</h1>
    },
    {
        path: "manageAnnouncement/*",
        element:
            (
                <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                    <ManageAnnouncement />
                </ProtectedRoute>
            )
    },
    {
        path: "manageAnnouncement/:id",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <EditFormRoute />
            </ProtectedRoute>
        )
    },
    {
        path: "manageAnnouncement/addannouncement",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="carrier" >
                <AddmanageAnnouncement />
            </ProtectedRoute>
        )
    },
    {
        path: "breastCancerRecord/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <BreastCancerRecord />
            </ProtectedRoute>
        )
    },
    {
        path: "starBucksCoffeCup/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <StarBucksCoffeCup />
            </ProtectedRoute>
        )
    },
    {
        path: "superBowl/*",
        element: (
            <ProtectedRoute requiredRole="admin" routeAuth="amInformation" >
                <SuperBowl />
            </ProtectedRoute>
        )
    }
];


export default function MangeRoutes() {
    return useRoutes(RoutesArray)
};